module.exports = __webpack_public_path__ + "fonts/typicons.95aa28e2.woff";